type CoverageArea = {
  id?: string | number;
  isDefault?: boolean;
  [key: string]: any;
};

type ClientWithCoverage = {
  coverageArea?: CoverageArea | null;
  coverageAreas?: CoverageArea[] | null;
  [key: string]: any;
};

export function listCoverageAreas(client?: ClientWithCoverage | string | null): CoverageArea[] {
  if (!client || typeof client !== "object" || !Array.isArray(client.coverageAreas)) return [];
  return client.coverageAreas.filter((area) => area?.id != null);
}

export function resolvePreferredCoverageArea(client?: ClientWithCoverage | string | null): CoverageArea | null {
  if (!client || typeof client !== "object") return null;
  if (client.coverageArea?.id != null) return client.coverageArea;

  const areas = listCoverageAreas(client);
  if (areas.length === 1) return areas[0];
  return null;
}

export function withResolvedCoverage<T extends ClientWithCoverage | string | null | undefined>(client: T): T {
  if (!client || typeof client !== "object") return client;

  const coverageArea = resolvePreferredCoverageArea(client);
  if (!coverageArea || client.coverageArea?.id === coverageArea.id) return client;

  return { ...client, coverageArea };
}
